const Transportdata = [
    {
        id : "1",
        schemeName: "Scheme for Strengthening Public Transport System",
        discription:"The Ministry of Road Transport and Highways has introduced scheme for strengthening Public Transport System in the Country in 2010. The objective of this scheme is to provide financial assistance for use of latest technologies and for preparation of total mobility plan for the States. You can find information related to this scheme, its objectives, funding, beneficiaries, etc. Information on how to apply, where to apply, concerned authority and officials is also available.",
        launchDate: "Year 2010",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "PLI scheme for drones and drone components",
    discription:"The Production Linked Incentive Scheme (PLI) for Drones and Drone Components (hereinafter referred to as ‘Scheme’) has been notified vide notification No. CG-DL-E-30092021-230076 dated 30/09/2021 in the Gazette of India. The Scheme has come into effect from the date of its Gazette Notification. For the implementation of this scheme during 2022-23 to 2024-25, a corpus of Rs 120 crores has been allocated. ",
    launchDate: " 30 September 2021",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Setu Bhartam Yojana",
    discription:"Setu Bharatam was launched by Prime Minister Narendra Modi on 4 March 2016 at a budget of ₹102 billion (US$1.3 billion), with an aim to make all national highways free of railway crossings by 2019.",
    launchDate: "4 March 2016",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Information on Registered Vehicle Scrapping Facility",
        discription:"The vehicle scrappage policy will come into effect from April 1, 2022.",
        launchDate: "1 April 2022",
        AnualFund: "12345"
    },
]
export default Transportdata;